import React, { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Reservation } from '../../../types/Reservation';
import { Button, ButtonColor, ButtonSize, ButtonVariant } from '../../Button';
import { ButtonPaddingSize } from '../../Button/Button.types';
import './EmailVerificationGate.css';

type UserRole = 'student' | null;

interface EmailVerificationGateProps {
  reservation: Reservation;
  onVerified: (email: string, role: UserRole) => void;
}

const EmailVerificationGate: React.FC<EmailVerificationGateProps> = ({
  reservation,
  onVerified
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (email.toLowerCase() === reservation.student.email.toLowerCase()) {
      onVerified(email, 'student');
    } else {
      setError(true);
    }
  };

  return (
    <div className="verification-banner">
      <div className="verification-banner-header">
        <LockOutlinedIcon sx={{ color: 'var(--blue-300)', fontSize: '1.25rem' }} />
        <Typography variant="body1" sx={{ fontWeight: 600, color: 'var(--blue-400)' }}>
          Verifica tu identidad para ver más información sobre tus clases
        </Typography>
      </div>
      <Typography variant="body2" sx={{ color: 'var(--gray-500)', mb: 1.5 }}>
        Ingresá el mail que usaste para reservar la clase.
      </Typography>
      <form onSubmit={handleSubmit} className="verification-form">
        <TextField
          type="email"
          size="small"
          placeholder="tu@mail.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError(false);
          }}
          error={error}
          helperText={error ? 'El mail no coincide con el de la reserva.' : ''}
          sx={{ minWidth: 240 }}
        />
        <Button
          type="submit"
          variant={ButtonVariant.CONTAINED}
          color={ButtonColor.PRIMARY}
          size={ButtonSize.SM}
          paddingSize={ButtonPaddingSize.SM}>
          Verificar
        </Button>
      </form>
    </div>
  );
};

export default EmailVerificationGate;
